import axios from "shared/utils/axios";
import { EHelloAction } from "./hello.type";

export const getHello = (cb) => async (dispatch) => {
  dispatch({ type: EHelloAction.GET_HELLO_REQUEST });
  try {
    const response = await axios.get("hello");
    dispatch(getHelloSuccess(response, cb));
  } catch (error) {
    dispatch(getHelloFailed(error));
  }
};

const getHelloSuccess = (data, cb) => {
  if (cb) cb();
  return {
    type: EHelloAction.GET_HELLO_SUCCESS,
    data,
  };
};

const getHelloFailed = (error) => {
  return {
    type: EHelloAction.GET_HELLO_FAILED,
    error,
  };
};

export const reduxshow = (a) => async (dispatch) => {
  dispatch({ type: EHelloAction.SHOW, data: a });
};
